import { useEffect } from "react";
import { useAppSelector } from "../../store/store";
import { useGenerateBridgeTokenMutation } from "../../services/api";
import { config } from "../../configs";
import { showNotification } from "../../services/showNotification";
import { tracker } from "../../services/mixpanel";

const solarStudyUrl =
  config?.REACT_APP_SOLAR_STUDY_URL || "https://solar.study";

const TimerWidget = ({ userId, isHide }: { userId: string; isHide: boolean }) => {
  console.log("userId", userId)
  const userEmail = useAppSelector((state) => state.login.email);
  const [generateBridgeToken] = useGenerateBridgeTokenMutation();

  const openInNewTab = (link: string) => {
    if (!link) return;
    const newTab = window.open("", "_blank");
    if (newTab) {
      newTab.location.href = link;
    } else {
      window.location.assign(link);
    }
  };

  const handleSolarStudyRedirect = async () => {
    tracker.dashboard.others.solarStudyTracker();

    try {
      if (!userEmail) {
        openInNewTab(solarStudyUrl);
        return;
      }

      const response = await generateBridgeToken(userEmail).unwrap();

      if (!response.success || !response.data?.bridgeToken) {
        throw new Error("Bridge Token not found");
      }

      openInNewTab(
        `${solarStudyUrl}/cross-auth?token=${response.data.bridgeToken}`
      );
    } catch (error) {
      showNotification(
        "error",
        "Failed to login user on Solar Study"
      );
      openInNewTab(solarStudyUrl);
    }
  };

  useEffect(() => {
    window.__IS_HIDE__ = isHide;
    if (window.__TIMER_TRACKER_INSTANCE__) {
      window.__TIMER_TRACKER_INSTANCE__.updateUI();
    }
  }, [isHide]);

  useEffect(() => {
    if (!userId) return;

    // pass userId to script
    window.__TIMER_USER_ID__ = userId;

    // expose redirect handler for widget link click
    window.__SOLAR_REDIRECT__ = handleSolarStudyRedirect;

    // prevent double script load
    if (window.__TIMER_SCRIPT_LOADED__) return;
    window.__TIMER_SCRIPT_LOADED__ = true;

    const script = document.createElement("script");
    script.src = "/timer-widget.js";
    script.async = true;

    script.onerror = () => {
      console.error("Failed to load timer-widget.js");
    };

    document.body.appendChild(script);

  }, [userId, userEmail]);

  return <div id="timerElement" />;
};

export default TimerWidget;
